// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 535) return "js/login.js";
	if (chunkId === 154) return "js/change_password.js";
	if (chunkId === 179) return "js/main.js";
	if (chunkId === 35) return "js/lots_all.js";
	if (chunkId === 9) return "js/logistical_lots_all.js";
	if (chunkId === 973) return "js/lots_detail.js";
	if (chunkId === 762) return "js/logistical_lots_detail.js";
	if (chunkId === 916) return "js/direct_outgoings.js";
	if (chunkId === 693) return "js/transports_all.js";
	if (chunkId === 847) return "js/transports_add.js";
	if (chunkId === 536) return "js/transports.js";
	if (chunkId === 736) return "js/instructions_all.js";
	if (chunkId === 897) return "js/delivery_reports_all.js";
	if (chunkId === 485) return "js/archives_all.js";
	if (chunkId === 860) return "js/archives_detail.js";
	if (chunkId === 361) return "js/companies_all.js";
	if (chunkId === 822) return "js/companies_detail.js";
	if (chunkId === 989) return "js/company_groups_all.js";
	if (chunkId === 996) return "js/delivery_points_all.js";
	if (chunkId === 849) return "js/transport_templates_all.js";
	if (chunkId === 753) return "js/transport_templates_edit.js";
	if (chunkId === 870) return "js/transport_templates_add.js";
	if (chunkId === 331) return "js/species_sizes_all.js";
	if (chunkId === 612) return "js/freshness_all.js";
	if (chunkId === 248) return "js/containers_all.js";
	if (chunkId === 334) return "js/fishing_modes_all.js";
	if (chunkId === 60) return "js/users_all.js";
	if (chunkId === 311) return "js/parameters_all.js";
	// return url for filenames based on template
	return undefined;
};